/**
 * Tema cozumleme - saf mantik, React'e bagli degil.
 *
 * `i18n/index.ts` ile AYNI oncelik sirasi: sunucu tercihi > tarayici
 * hafizasi > cihaz tercihi > varsayilan. `system`/`null` "cihazi takip et"
 * demek ve ikisi FARKLI olgular (bkz. backend `db/models.py` UserSettings.theme
 * yorumu): `null` kullanicinin hic secim yapmadigi, `'system'` ise ACIKCA
 * "cihazi takip et"i sectigi durum - arayuzun hangi radyo'nun isaretli
 * oldugunu bilebilmesi icin ikisi ayri tutuluyor.
 */

export type ThemePreference = 'dark' | 'light' | 'system'
export type ResolvedTheme = 'dark' | 'light'

const STORAGE_KEY = 'hedefai.theme'
const VALID: readonly ThemePreference[] = ['dark', 'light', 'system']

export function normalizeThemePreference(value: string | null | undefined): ThemePreference | null {
  if (!value) return null
  return (VALID as readonly string[]).includes(value) ? (value as ThemePreference) : null
}

function safeRead(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    // Gizli sekme / depolama kapali: tema tercihi ugruna uygulamayi
    // acilmaz yapmak kabul edilemez (bkz. i18n/index.ts ayni gerekce).
    return null
  }
}

function safeWrite(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    /* yok sayilir */
  }
}

export function readStoredTheme(): ThemePreference | null {
  if (typeof window === 'undefined') return null
  return normalizeThemePreference(safeRead(STORAGE_KEY))
}

export function writeStoredTheme(value: ThemePreference): void {
  if (typeof window === 'undefined') return
  safeWrite(STORAGE_KEY, value)
}

export function prefersLightDevice(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia('(prefers-color-scheme: light)').matches
}

/** `system`/`null` -> gercek cihaz tercihine cozumlenir; digerleri sabit. */
export function resolveTheme(preference: ThemePreference | null): ResolvedTheme {
  if (preference === 'dark' || preference === 'light') return preference
  return prefersLightDevice() ? 'light' : 'dark'
}

export function applyResolvedTheme(resolved: ResolvedTheme): void {
  if (typeof document === 'undefined') return
  document.documentElement.dataset.theme = resolved
  document.documentElement.style.colorScheme = resolved
}
